import { render } from "./sglm-salahkarsamiti.vue?vue&type=template&id=1acfe157&scoped=true"
import script from "./sglm-salahkarsamiti.vue?vue&type=script&lang=js"
export * from "./sglm-salahkarsamiti.vue?vue&type=script&lang=js"

import "./sglm-salahkarsamiti.vue?vue&type=style&index=0&id=1acfe157&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acfe157"]])

export default __exports__